import { Skeleton } from '@parrot-software/design-system';
import { cn } from '@parrot-software/utils';

type SubscriptionBlockFormSkeletonProps = {
  isEdition?: boolean;
};

/**
 * Loading placeholder for `SubscriptionBlockForm`.
 *
 * Mirrors the form layout (two fields + footer button) so the UI does not
 * jump when the stores query resolves.
 *
 * @param props - Component properties (see `SubscriptionBlockFormSkeletonProps`)
 * @returns React element rendering the skeleton placeholder
 */
export const SubscriptionBlockFormSkeleton = ({ isEdition = false }: SubscriptionBlockFormSkeletonProps) => (
  <div className={cn('flex flex-col gap-6', { 'min-h-0 flex-1': isEdition })}>
    <div className={cn('grid grid-cols-1 gap-4 md:grid-cols-2', { 'min-h-0 flex-1 px-4 pb-5': isEdition })}>
      <div className="flex flex-col gap-1">
        <Skeleton className="h-4 w-32" />
        <Skeleton className="h-9 w-full rounded-md" />
      </div>
      <div className="flex flex-col gap-1">
        <Skeleton className="h-4 w-32" />
        <Skeleton className="h-9 w-full rounded-md" />
      </div>
    </div>
    <div className={cn('flex justify-end', { 'shrink-0 p-4 pt-0': isEdition })}>
      <Skeleton className="h-10 w-32 rounded-md" />
    </div>
  </div>
);
